/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerAccount } from '../../models/customer-account';

export interface GetLabs$Params {
  bpGuid: string;
  accountId?: number;
  shipToAddressId?: number;
}

export function getLabs(http: HttpClient, rootUrl: string, params: GetLabs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerAccount>>> {
  const rb = new RequestBuilder(rootUrl, getLabs.PATH, 'get');
  if (params) {
    rb.query('bpGuid', params.bpGuid, {});
    rb.query('accountId', params.accountId, {});
    rb.query('shipToAddressId', params.shipToAddressId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerAccount>>;
    })
  );
}

getLabs.PATH = '/sample/instruction/labs/list';
